import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import useSecureStorage from '../../hooks/useSecureStorage';

import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const WalletRecoveryComplete: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	const { t } = useTranslation();
	const { setLogin, getLogin } = useSecureStorage()
	
	useEffect(() => {
		const initLogin = async () => {
			const timer = setTimeout(async () => {
				await setLogin()
			}, 0)
			return () => clearTimeout(timer)
		}
		initLogin()
	}, [])

	const handleStartService = async () => {
		await setLogin()
		await setTimeout(() => {
			navigate(`/UnlockScreen`, { replace: true, state: { } });
		}, 500)
		
	}

	const styles = {
		content: {
			display: "flex",  
			flexDirection: "column",
			justifyContent: 'center',
			alignItems: 'center',
			marginBottom: 30,
			marginTop: "90px"
		} as React.CSSProperties,
		image: {
			width: 120,
			height: 120,
			marginBottom: 20
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			textAlign: 'center'
		} as React.CSSProperties,
		footer: {
			width: '100%'
		} as React.CSSProperties,
		button: {
			borderRadius: 10,
			alignItems: 'center',
			width: '100%',
			height: 54,
			justifyContent: 'center'
		} as React.CSSProperties,
		buttonText: {
			color: theme.static_white,
			fontSize: 16
		} as React.CSSProperties,
	}
	
	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.content}>
				<img
					src="./img/Rectangle.png" // 실제 이미지 경로로 수정 필요
					alt="Recovery Complete"
					style={styles.image}
				/>
				<CustomText style={{ ...styles.title, color: theme.label_strong }}>
					{t('wallet_recovery_complete_message_04')}
				</CustomText>
				<CustomText style={{ ...styles.title, color: theme.label_strong }}>
					{t('wallet_recovery_complete_message_05')}
				</CustomText>
			</div>

			<div style={styles.footer}>
				<CustomButton
					containerStyle={{ ...styles.button, backgroundColor: theme.primary_normal }}
					textStyle={styles.buttonText}
					onPress={handleStartService}
					text={t('wallet_recovery_complete_message_06')}
					withBackground={true}
					backgroundColor={theme.primary_normal}
				/>
			</div>
		</div>
	)
}

export default WalletRecoveryComplete
